import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { Loader } from '@pw-tech/omni-ui';
const CEE = () => {
  const router = useRouter();
  useEffect(() => {
    router.push({
      pathname: '/admission-process'
    });
  }, [router.isReady]);
  return <>
      <div className="flex items-center justify-center h-[90vh]">
        <Loader message="Loading..." data-sentry-element="Loader" data-sentry-source-file="cee-exam.tsx" />
      </div>
    </>;
};
export default CEE;